import { Ban } from 'lucide-react'

export const BusinessInactive = ({ message }: { message: string }) => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-page p-4 text-center sm:p-6">
    <Ban className="size-10 text-error" />
    <h1 className="text-xl font-semibold text-ink">Business suspended</h1>
    <p className="max-w-md text-sm text-text-2">{message}</p>
    <button type="button" onClick={() => window.location.reload()} className="text-sm font-medium text-ink underline">
      Try again
    </button>
  </div>
)
